import React, { useState } from "react";
import { toast } from "sonner";
import { HardHat, Save } from "lucide-react";
import { progresKonstruksi, fmtSisa } from "../../lib/konstruksi";
import { C, FONT_BODY } from "./theme";

const inp = { width: "100%", marginTop: 3, padding: "7px 10px", border: `1.5px solid ${C.line}`, borderRadius: 10, fontSize: 12.5, fontFamily: FONT_BODY, boxSizing: "border-box" };
const BUKAN = new Set(["Alam", "Karakter", "Kendaraan", "Sponsor"]);

// Form wajib untuk gedung konstruksi: durasi (jam) + bangunan lanjutan yang muat di tapak. Saat 100% bangunan berganti otomatis.
export function KonstruksiForm({ b, def, defs, onSave }) {
  const k = b.konstruksi;
  const [jam, setJam] = useState(k?.jam || 24);
  const [lanjut, setLanjut] = useState(k?.lanjut_bid || "");
  let W = def.w || 1, Hh = def.h || 1;
  if ((b.rot || 0) % 2 === 1) [W, Hh] = [Hh, W];
  const pilihan = (defs || []).filter(d => !BUKAN.has(d.category) && !d.konstruksi && d.paintCode && (d.w || 1) <= W && (d.h || 1) <= Hh).sort((a, c) => a.name.localeCompare(c.name));
  const pr = progresKonstruksi(k);

  return (
    <div data-testid="konstruksi-form" style={{ borderTop: `1px solid ${C.line}`, paddingTop: 10, marginBottom: 12, display: "flex", flexDirection: "column", gap: 8 }}>
      <p style={{ margin: 0, fontSize: 10, fontWeight: 700, letterSpacing: 1.5, color: k ? C.t3 : C.danger, textTransform: "uppercase", fontFamily: FONT_BODY, display: "flex", alignItems: "center", gap: 6 }}>
        <HardHat size={12} /> Jadwal pembangunan {k ? "" : "· wajib diisi"}
      </p>
      {pr && <div data-testid="konstruksi-progres" style={{ fontSize: 12, color: C.sub, fontFamily: FONT_BODY }}>
        <div style={{ height: 8, borderRadius: 99, background: C.line, overflow: "hidden", marginBottom: 4 }}><div style={{ width: `${Math.round(pr.p * 100)}%`, height: "100%", background: pr.selesai ? "#2ecc71" : "#f2b224" }} /></div>
        {pr.selesai ? "Selesai — berganti saat peta dimuat" : `${Math.round(pr.p * 100)}% · sisa ${fmtSisa(pr.sisaMs)}`}
      </div>}
      <label style={{ fontSize: 11, color: C.sub, fontFamily: FONT_BODY }}>Lama pembangunan (jam)
        <input data-testid="konstruksi-jam" type="number" min={1} max={720} value={jam} onChange={e => setJam(e.target.value)} style={inp} /></label>
      <label style={{ fontSize: 11, color: C.sub, fontFamily: FONT_BODY }}>Bangunan setelah selesai (muat di tapak {W}×{Hh})
        <select data-testid="konstruksi-lanjut" value={lanjut} onChange={e => setLanjut(e.target.value)} style={inp}>
          <option value="">— pilih bangunan —</option>
          {pilihan.map(d => <option key={d.bid} value={d.bid}>{d.name} ({d.w}×{d.h})</option>)}
        </select></label>
      <button data-testid="konstruksi-simpan" onClick={() => {
        const j = Number(jam);
        if (!(j >= 1)) return toast.error("Isi lama pembangunan minimal 1 jam");
        if (!lanjut) return toast.error("Pilih bangunan setelah selesai");
        const mulai = k?.mulai_at && k.jam === j ? k.mulai_at : new Date().toISOString();
        onSave({ jam: j, mulai_at: mulai, selesai_at: new Date(new Date(mulai).getTime() + j * 3600e3).toISOString(), lanjut_bid: lanjut });
        toast.success("Jadwal pembangunan diterapkan — jangan lupa Simpan kota");
      }} style={{ width: "100%", padding: "8px 0", background: C.ink, color: "#fff", border: 0, borderRadius: 99, fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: FONT_BODY, display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
        <Save size={13} /> {k ? "Perbarui jadwal" : "Mulai pembangunan"}
      </button>
    </div>
  );
}
